import { default as Surface } from './surface';

export default {get Surface () {
    return Surface;
},};